import { type MutableRefObject, useRef } from "react";

export const useMutableRefObject = <T>(value: T): MutableRefObject<T> => {
  return useRef<T>(value) as MutableRefObject<T>;
};
